module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0e598573e7513953849e7877acfdfd19.png";